<template>
  <section>
    <div id="reg">
      <div class="header">
        <div class="container">
          <div class="logo">
            <a href="#/">
              <img src="/static/images/logo.png" />
            </a>
          </div>
        </div>
      </div>
      <div class="container">
        <form action lay-filter="huiyuanReg" class="layui-form">
          <div class="regbox">
            <div style="position: absolute; right: 30px; top: 50px; font-size: 12px;">
              已有快力文账号？
              <router-link to="/login">
                <a href="javascript;," class="color-primary">立即登录</a>
              </router-link>
            </div>
            <div class="hd flex">
              <li class="active">找回密码</li>
              <!-- <li :class="type=='1'?'active':''" @click="changeType('1')">会员注册</li>
              <li @click="changeType('2')" :class="type=='2'?'active':''">企业注册</li> -->
            </div>
            <div class="bd">
              <div class="huiyuan">
                <div class="row">
                  <input
                    type="text"
                    placeholder="手机号"
                    name="mobile"
                    v-model="mobile"
                        maxlength="11"
                    lay-verify="phone"
                    class="layui-input"
                  />
                </div>
                <div class="row">
                  <input
                    type="password"
                    placeholder="设置你的登录密码"
                    name="pwd1"
                    lay-verify="required"
                    class="layui-input"
                  />
                </div>
                <div class="row">
                  <input
                    type="password"
                    placeholder="请再次输入你的密码"
                    name="pwd2"
                    lay-verify="required"
                    class="layui-input"
                  />
                </div>
             
                <div class="row">
                  <div class="fr">
                    <button
                      type="button"
                      :class="countdown>0 ? 'layui-btn layui-btn-disabled ' :'layui-btn regbtn'"
                      @click="getcode"
                    >{{countdown>0 ? countdown+"S后重新获取":"获取验证码"}}</button>
                  </div>
                  <div style="overflow: hidden;">
                    <input
                      type="text"
                      placeholder="短信验证码"
                      name="smscode"
                      lay-verify="required"
                      class="layui-input"
                    />
                  </div>
                </div>
              </div>


              <div style="margin-top: 30px;">
                <button
                  type="button"
                  lay-submit
                  lay-filter="huiyuanReg"
                  :class="!checked?'layui-btn layui-btn-disabled layui-btn-fluid' :'layui-btn layui-btn-fluid regbtn'"
                >注册</button>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="container loginfooter">
        <div class="link">
          <span v-for="(item,index) in indexData.index_link_bottom" :key="index">
            <a :href="item.url">{{item.remark}}</a>
            {{index < indexData.index_link_bottom.length-1 ? "|" : ""}}
          </span>
        </div>
        <div class="mt10">{{indexData.index_copyright}}</div>
      </div>
    </div>
  </section>
</template>

<script>
import Header from "../components/header";
import Footer from "../components/footer";
export default {
  components: {
    Header,
    Footer
  },
  name: "findpwd",
  data() {
    return {
      mobile: "",
        checked:false,
      countdown: 0,
      indexData: {},

    };
  },
  methods: {

    async someconfig() {
      let that = this;
      layui.use(["form", "layer"], function() {
        var form = layui.form;
        var layer = layui.layer;
        form.verify("huiyuanReg", {});
        form.on("submit(huiyuanReg)", async data => {
          let submitData = data.field;
          if (submitData.pwd1 != submitData.pwd2) {
            layer.alert("2次输入的密码不一致", { icon: 5 });
            return;
          }

          submitData["userpwd"] = submitData.pwd1;
          delete submitData.pwd1;
          delete submitData.pwd2;
          let res = await that.$fetch("member/findpwd", {
            body: submitData
          });
          // console.log("result",result)
          // return;
           if (!res) return;
         
              layer.alert("找回成功", { icon: 1 });
            that.$router.push("/login")
        //   let result =await that.$fetch("login/login", { body: {
        //     username:submitData.username,userpwd:submitData.userpwd
        //   } });
       
        //   sessionStorage.guid = result.guid;
        //   localStorage.jinruser = JSON.stringify(result.user);
        //   sessionStorage.user = localStorage.jinruser;
        //   setCookie("guid", result.guid, 2);
        //   if (window.history.length <= 1 || that.oldUrl == "/login") {
        //     that.$router.push({ path: "/" });
        //     return false;
        //   } else {
        //     console.log("window.history", window.history);
        //     that.$router.go(-1);
        //   }

        });
      });
    },

    async getcode() {
      let result = await this.$fetch("tool/sendsms", {
        body: { mobile: this.mobile }
      });
      if (result || result == 0) {
        this.checked = true;
        let time = 59;
        let timeId = setInterval(() => {
          time--;
          this.countdown = time;
          if (time <= 0) {
            clearInterval("timeId");
          }
        }, 1000);
      }
    },

  },
//    beforeRouteEnter (to, from, next){
//      next(vm => {
//        // 通过 `vm` 访问组件实例,将值传入oldUrl
//        vm.oldUrl = from.path
//      })
//    },
  async mounted() {
        // console.log("window.history", window.history,this.oldUrl);
    //   console.log(this.$router.push('/login'))
    this.indexData = await this.$fetch("Index/indexdata");
    this.someconfig();
  }
};
</script>


<style lang='scss' scoped>


</style>



// WEBPACK FOOTER //
// src/pages/findpwd.vue